'use client';

// Error boundaries must be Client Components
import localFont from 'next/font/local';
import Image from 'next/image';
import Link from 'next/link';
import Script from 'next/script';

const fontOpenSans = localFont({
  src: '../../public/fonts/OpenSans-VariableFont_wdth,wght.ttf',
  variable: '--font-opensans',
});
const fontOpenSansitalic = localFont({
  src: '../../public/fonts/OpenSans-Italic-VariableFont_wdth,wght.ttf',
  variable: '--font-opensansitalic',
});
const fontRoboto = localFont({
  src: [
    { path: '../../public/fonts/Roboto-Thin.ttf', weight: '100' },
    { path: '../../public/fonts/Roboto-Light.ttf', weight: '300' },
  ],
  variable: '--font-roboto',
});
export default function GlobalError() {
  return (
    // global-error must include html and body tags
    <html lang="en-US">
      <Script src="https://kit.fontawesome.com/c9adc7a8be.js" crossOrigin="anonymous" />
      <body
        className={`${fontRoboto.variable} ${fontOpenSans.variable} ${fontOpenSansitalic.variable} flex min-h-screen flex-col xl:mx-auto xl:max-w-[90rem] xl:overflow-x-visible`}
      >
        <div className="">
          <header role="banner" id="Main-Header">
            <div className="!mx-0 !my-0 bg-white p-0 drop-shadow-lg">
              <div className="flex justify-between p-8 md:p-4">
                <div
                  className="flex items-center justify-items-center"
                  data-testid="main-header-logo-container"
                >
                  <Link
                    data-testid="main-header-link-logo"
                    href={process.env.NEXT_PUBLIC_UMGC_LINK || '#'}
                    className="w-7/12 md:w-2/4 lg:w-3/4"
                  >
                    <Image
                      src={'/Logo.svg'}
                      alt={'UMGC: University of Maryland Global Campus'}
                      width={300}
                      height={100}
                      className="border-r border-black pr-2"
                      priority
                    />
                  </Link>
                  <h1 className="pl-2 text-sm font-light md:text-xl lg:text-xl" aria-label="MyUMGC">
                    MyUMGC
                  </h1>
                </div>
              </div>
            </div>
          </header>
          <div className="mx-0 my-8 bg-white p-6 drop-shadow-lg">
            <div className="flex items-center gap-2">
              <i className="fas fa-exclamation-triangle text-3xl text-primary" />
              <h2 className="text-4xl font-normal">Page Couldn&apos;t load</h2>
            </div>
            <p className="mt-4 text-base text-Paragraph">
              We&apos;re having trouble loading this page right now. This might be due to a
              temporary issue or a connection problem.
            </p>
            <p className="mt-4 text-base text-Paragraph">You can:</p>
            <ul className="mt-4 list-disc pl-8 text-base text-Paragraph">
              <li className="my-2">Try refreshing the page</li>
              <li className="my-2">Check your internet connection</li>
              <li className="my-2">Contact us if the problem persists</li>
            </ul>
          </div>
        </div>
      </body>
    </html>
  );
}
